import Vue from 'vue'
import axios from 'axios'
import userManager from '@amsom-habitat/user-manager'

const storeToken = Vue.observable({
    token: userManager.getToken(),
});

function logout () {
    window.stop()
    storeToken.token = null
    userManager.logout()
}

function authenticate (credentials) {
    let data = JSON.stringify({ '_username': credentials.username, '_password': credentials.password, '_app': 'Sollicitation' })

    let config = {
        method: 'post',
        url: process.env.VUE_APP_API_URL + '/login',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    }

    logout()

    return axios(config)
        .then(response => {
            return response.data.token
        })
        .then(token => {
            // Je stocke le token dans le local storage
            storeToken.token = token
            console.log(storeToken.token)
            return true
        })
}

export default {
    authenticate,
    logout,
    storeToken
}
